import React, { FC } from "react";
import { graphql } from "gatsby";
import Layout from "../components/App/Layout";
import SuccessStoryDetailsContent from '../components/SuccessStories/SuccessStoriesDetailsContent';
import SEO from "../components/App/SEO"
import { HeadProps, SuccessStoryQueryData } from "../utils/core";
import PageBanner from "../components/App/PageBanner";
import { useTranslation } from "../plugins/i18next/ea-react-i18next";

export const Head: FC<HeadProps> = ({ data }) => {
    const article = data.markdownRemark;
    return <SEO title={article?.frontmatter?.title} description={article?.frontmatter?.description} />;
};

const SuccessStory: FC<{ data: SuccessStoryQueryData }> = ({ data }) => {
    const { t } = useTranslation("pages", { keyPrefix: 'successStories' });
    const { markdownRemark } = data;
    const successstory = markdownRemark;

    return (
        <Layout>
            <PageBanner
                pageTitle={t('title')}
                homePageText={t('home')}
                homePageUrl="/"
            />
            <SuccessStoryDetailsContent successstory={successstory} />
        </Layout>
    );
};

export default SuccessStory;


export const query = graphql`
query StudyQuery($id: String, $language: String) {
    markdownRemark(id: { eq: $id}) {
        frontmatter {
            category
            date
            blogimage {
                childImageSharp {
                    gatsbyImageData
                }
            }
            slug
            title
            subtitle
            description
            language
            sector
            successstoryfile {
            publicURL
            }
            videoId
            videoTitle
        }
        html
        id
    }
    locales: allLocale(filter: {
        language: {
            eq: $language
        },
        ns: {
            in: ["components", "pages"]
        }
    }) {
        edges {
            node {
                ns
                language
                data
            }
        }
    }
}
`;